import React, { useEffect, useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";

export const OTPModal = ({ show, handleClose, verifyOTP,isloading }) => {

  const [otp, setotp] = useState("")

  const onVerifyOTPEvent = ()=>{
    verifyOTP(otp)
  }

  useEffect(() => {
    setotp("")
  }, [show])
  

  return (
    <Modal show={show.isSuccess || show.isFailed} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{show.isFailed?"YOUR DATA WAS NOT FOUND":"VERIFICATION"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {show.isSuccess?<>
        <h6>
          You will receive an OTP on your registered <b>Email</b>
        </h6>
        <Form.Group className="mb-3">
          <Form.Control
            placeholder="----"
            type={"number"}
            value={otp}
            onChange={(e) => setotp(e.target.value)}
          />
        </Form.Group>
        <Button
          variant="primary"
          className="loader-btn"
          style={{ float: "right" }}
          onClick={onVerifyOTPEvent}
          disabled={isloading ? true : false}
        >
          Verify OTP {isloading ? <Spinner animation="border" role="status" variant="light"></Spinner>:""}
        </Button>
        </>:""}
      </Modal.Body>
    </Modal>
  );
};
